import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
	// viewBox="0 0 16 16"
	return (
		<>
			<path
				fill={color}
				d="M14.45 16H1.55C.7 16 0 15.3 0 14.44V1.56C0 .7.7 0 1.56 0h12.89C15.3 0 16 .7 16 1.56v12.89c0 .85-.7 1.55-1.55 1.55ZM1.55 1.04a.51.51 0 0 0-.5.51v12.9c0 .27.23.5.5.5h12.9a.5.5 0 0 0 .5-.5V1.54a.51.51 0 0 0-.5-.5H1.55Z"
			/>
			<path
				fill={color}
				d="M12.8 2.84H3.2c-.3 0-.54.25-.54.54v1.9c0 .3.24.53.54.53h9.6c.3 0 .55-.24.55-.54V3.38c0-.3-.24-.54-.54-.54ZM4.95 7.02H3.07a.42.42 0 0 0-.41.41v1.89c0 .23.18.41.41.41h1.88a.4.4 0 0 0 .42-.41V7.43a.42.42 0 0 0-.42-.41Zm3.99 0H7.06a.42.42 0 0 0-.42.41v1.89c0 .23.19.41.42.41h1.88c.23 0 .42-.18.42-.41V7.43a.42.42 0 0 0-.42-.41Zm-3.99 3.42H3.07a.42.42 0 0 0-.41.42v1.88c0 .23.18.42.41.42h1.88c.24 0 .42-.2.42-.42v-1.88a.42.42 0 0 0-.42-.42Zm3.99 0H7.06a.42.42 0 0 0-.42.42v1.88c0 .23.19.42.42.42h1.88c.23 0 .42-.2.42-.42v-1.88a.42.42 0 0 0-.42-.42Zm3.99-3.42h-1.88a.42.42 0 0 0-.42.41v5.3c0 .24.19.43.42.43h1.88c.23 0 .42-.2.42-.42v-5.3a.42.42 0 0 0-.42-.42Z"
			/>
		</>
	);
}
